import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["box"]

  initialize() {
    this.debouncedEqualizeHeights = this.debounce(this.equalizeHeights, 100)
    this.boxObservers = []
  }

  connect() {
    window.addEventListener("resize", this.debouncedEqualizeHeights)
    this.debouncedEqualizeHeights()
  }

  disconnect() {
    window.removeEventListener("resize", this.debouncedEqualizeHeights)
    this.boxObservers.forEach((o) => o.disconnect())
  }

  // Called when a .box is added
  boxTargetConnected(box) {
    this.observeBox(box)
    this.debouncedEqualizeHeights()
  }

  // Called when a .box is removed
  boxTargetDisconnected(box) {
    // Remove its observer
    this.boxObservers = this.boxObservers.filter((observer) => {
      const target = observer.__box
      if (target === box) {
        observer.disconnect()
        return false
      }
      return true
    })

    this.debouncedEqualizeHeights()
  }

  observeBox(box) {
    if (typeof this.debouncedEqualizeHeights !== "function") {
      return
    }

    const observer = new MutationObserver(this.debouncedEqualizeHeights)
    observer.observe(box, {
      childList: true,
      subtree: true,
      characterData: true,
    })
    observer.__box = box // tag it so we can remove later
    this.boxObservers.push(observer)
  }

  observeAllBoxes() {
    this.boxTargets.forEach((box) => this.observeBox(box))
  }

  equalizeHeights = () => {
    if (this.boxTargets.length < 2) return

    let maxHeight = 0
    const headerHeights = []

    this.boxTargets.forEach((box) => {
      const content = box.querySelector(".box-content")
      const header = box.querySelector(".box-header")

      if (content) content.style.minHeight = ""
      if (header && content) content.offsetHeight

      const totalHeight = box.scrollHeight
      const headerHeight = header?.offsetHeight || 0
      headerHeights.push(headerHeight)
      maxHeight = Math.max(maxHeight, totalHeight)
    })

    this.boxTargets.forEach((box, i) => {
      const content = box.querySelector(".box-content")
      if (content) {
        const contentHeight = maxHeight - headerHeights[i]
        content.style.minHeight = `${contentHeight}px`
      }
    })
  }

  debounce(fn, delay) {
    let timeout
    return (...args) => {
      clearTimeout(timeout)
      timeout = setTimeout(() => fn.apply(this, args), delay)
    }
  }
}
